import { z } from "zod";
import { EntityRef, EntityType } from "./schemas/event.js";
/** App-level chat stream (POST /api/chat/threads/:id/messages -> SSE). The UI
 * never sees raw Anthropic stream shapes; the server maps them onto these. */
export const ChatEvent = z.discriminatedUnion("event", [
    z.object({ event: z.literal("message_start"), thread_id: z.string().uuid(), message_id: z.string().uuid() }),
    z.object({ event: z.literal("text_delta"), text: z.string() }),
    z.object({ event: z.literal("tool_call_start"), call_id: z.string(), name: z.string(), label: z.string() }),
    z.object({
        event: z.literal("tool_call_result"),
        call_id: z.string(),
        ok: z.boolean(),
        summary: z.string(),
        entity: EntityRef.nullable(),
        event_id: z.string().uuid().nullable(),
        undoable: z.boolean(),
        error: z.string().nullable(),
    }),
    z.object({
        event: z.literal("question"),
        question_id: z.string(),
        text: z.string(),
        options: z.array(z.string()).nullable(),
    }),
    z.object({
        event: z.literal("entity_changed"),
        type: EntityType,
        id: z.string().uuid(),
        project_id: z.string().uuid().nullable(),
    }),
    z.object({
        event: z.literal("message_end"),
        stop_reason: z.string().nullable(),
        usage: z.object({ input: z.number(), output: z.number(), cache_read: z.number() }).nullable(),
    }),
    z.object({ event: z.literal("error"), message: z.string(), retryable: z.boolean() }),
]);
/** Persisted message shape returned by GET .../messages: the same parts the stream builds. */
export const ChatPart = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("text"), text: z.string() }),
    z.object({
        kind: z.literal("tool_call"),
        call_id: z.string(),
        name: z.string(),
        label: z.string(),
        input: z.record(z.string(), z.unknown()),
        ok: z.boolean().nullable(),
        summary: z.string().nullable(),
        entity: EntityRef.nullable(),
        event_id: z.string().uuid().nullable(),
        undone: z.boolean(),
        error: z.string().nullable(),
    }),
    z.object({
        kind: z.literal("question"),
        question_id: z.string(),
        text: z.string(),
        options: z.array(z.string()).nullable(),
    }),
]);
export const ChatMessage = z.object({
    id: z.string().uuid(),
    thread_id: z.string().uuid(),
    role: z.enum(["user", "assistant"]),
    parts: z.array(ChatPart),
    interrupted: z.boolean(),
    created_at: z.string(),
});
export const ChatThread = z.object({
    id: z.string().uuid(),
    kind: z.enum(["project", "intake"]),
    project_id: z.string().uuid().nullable(),
    title: z.string(),
    last_message_at: z.string().nullable(),
    created_at: z.string(),
});
//# sourceMappingURL=chatEvents.js.map